import { theme } from '@styles';

export const styles = {
  chooseAvatarFirstButton: {
    mx: 'auto',
    variant: 'primary',
  },
  chooseAvatarModal: {
    backgroundColor: theme.colors.white[10],
    border: `1px solid ${theme.colors.white[10]}`,
    borderRadius: '0px',
    style: {
      backdropFilter: 'blur(17px)',
    },
  },
};

export const getChooseAvatarModalStyles = ({ isTabletSM }) => ({
  ...styles.chooseAvatarModal,
  maxHeight: isTabletSM ? 'auto' : 845,
  minHeight: isTabletSM ? '100vh' : 0,
  paddingBottom: isTabletSM ? 50 : 0,
});

export const getChooseAvatarFirstButtonStyles = ({ isTabletSM }) => ({
  ...styles.chooseAvatarFirstButton,
  width: isTabletSM ? '100%' : '396px',
});
